var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"btn",staticClass:"jc-btn",class:[
        _vm.type ? _vm.type : '',
        _vm.size ? _vm.size : '',
        _vm.radius && !_vm.rightAngle ? 'is-radius' : '',
        _vm.loading ? 'is-loading' : '',
        _vm.disabled ? 'is-disabled' : '',
        _vm.rightAngle ? 'is-right-angle': '',
        _vm.half ? 'is-half' : '',
        _vm.block ? 'is-block' : ''],attrs:{"type":"button","autofocus":false},on:{"click":function($event){$event.stopPropagation();return _vm.onClickHandle($event)}}},[(_vm.loading)?[_c('i',{staticClass:"jc-btn-loading jc-icon icon-loading"})]:_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-69b01eca","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/button/button.vue
// module id = null
// module chunks = 